<template>
    <v-dialog
        class="replace-wechat-dialog"
        :open="name === 'replaceWechatDialog'"
        :title="showTitle ? $t('绑定微信') : ''"
        @close="$emit('update:name', '')"
    >
        <div
            v-if="showTitle"
            slot="subtitle"
        >
            <p>{{ $t('请使用新微信账号扫描二维码') }}</p>
            <p>{{ $t('绑定成功后原先绑定的手机和微信号都将解绑') }}</p>
        </div>
        <div class="body">
            <div
                v-if="step === 1"
                class="qrcode"
            >
                <qd-login-wx
                    render-id="WxLoginReplace"
                    :show-tips="false"
                    :custom-message-handle="true"
                    :redirect-url="WECHAT.BIND_WECHAT"
                    @message="handleMessageHandler"
                />
                <div class="button-row">
                    <v-button
                        class="btn"
                        size="large"
                        @click="handleReturnValid"
                    >
                        {{ $t('返回验证') }}
                    </v-button>
                </div>
            </div>
            <div
                v-else-if="step === 2"
                class="step2"
            >
                <div class="tip-icon" />
                <div class="tip-text">
                    <p>{{ $t('微信号{wechat}已绑定账号', { wechat }) }}</p>
                    <p>{{ account }}</p>
                </div>
                <div class="tip-description">
                    <p>
                        <i18n-t path="是否将该微信号绑定至当前账号 {aid}？" tag="span">
                            <span slot="aid" class="blue">{{ aid }}</span>
                        </i18n-t>
                    </p>
                    <p>
                        <i18n-t path="替换绑定后，原绑定账号{account}将与该微信号解绑" tag="span">
                            <span slot="account" class="blue">{{ account }}</span>
                        </i18n-t>
                    </p>
                </div>
                <div class="btn-row">
                    <v-button
                        status="primary"
                        style="margin-right:20px;"
                        :loading="bindLoading"
                        size="large"
                        @click="handleBindCurrentCount"
                    >
                        {{ $t('绑定至当前账号') }}
                    </v-button>
                    <v-button
                        status="default"
                        size="large"
                        @click="step = 1"
                    >
                        {{ $t('重新扫码') }}
                    </v-button>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import Gateway from '@/utils/Gateway';
import QdLoginWx from '../wechat.js';
import WECHAT from './const';

const CHANGE_WX_URL = '/v1/basic.account.account_web.AccountWeb/ForceAddAccount'; // 替换微信
export default {
    components: {
        QdLoginWx,
    },
    props: {
        returnDialogName: {
            type: String,
            default: String,
        },
        aid: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            WECHAT,
            wechat: '',
            account: '',
            step: 1,
            bindLoading: false,
        };
    },
    computed: {
        showTitle() {
            return this.step === 1;
        },
    },
    methods: {
        handleReturnValid() {
            // this.$emit('update:name', this.returnDialogName)
            this.$emit('on-return-validate');
        },
        handleMessageHandler(res) {
            const { data } = res.data;
            const code = parseInt(data.code, 10);
            if (code === 0) {
                this.$message.success(this.$t('微信验证成功'));
                this.$emit('on-success');
                this.$emit('update:show', false);
            } else if (code === 300010) {
                this.step = 2;
                this.openid = data.data.openid;
                this.account = data.data.aid;
            } else {
                this.$message.error(data.message);
            }
        },
        handleToggleDialogVisiable(show) {
            this.$emit('update:show', show);
            console.log(show);
        },
        handleBindCurrentCount() {
            const params = {
                openid: this.openid,
            };
            Gateway.post(CHANGE_WX_URL, params)
                .then(() => {
                    this.$emit('on-success');
                    this.$emit('update:show', false);
                })
                .catch((err) => {
                    this.$message.error(err || this.$t('网络故障，请稍后再试'));
                });
        },
    },
};
</script>

<style lang="less">
.replace-wechat-dialog {
    .v-dialog__subtitle {
        margin-top: 5px;
        font-size: 14px;
        line-height: 20px;
        color: #ff4222;
        text-align: center;
    }
    .v-dialog__content {
        width: 400px;
        padding: 40px 0 60px;
        .v-dialog__body {
            margin-top: 35px;
        }
    }
    .body {
        .button-row {
            margin-top: 40px;
            margin-bottom: -15px;
            .btn {
                width: 150px;
            }
        }
        .qrcode {
            // max-width: 200px;
            // max-height: 200px;
            display: block;
            margin: 0 auto;
        }
        .step2 {
            margin-top: -70px;
            margin-bottom: -15px;
            padding: 0 20px;
            .tip-icon {
                width: 40px;
                height: 40px;
                background: url('../../assets/ic_warning@2x.png') no-repeat;
                background-size: cover;
                margin: 0 auto;
            }
            .tip-text {
                margin-top: 20px;
                font-size: 24px;
                line-height: 33px;
                color: #1e2330;
                text-align: center;
                word-break: break-all;
            }
            .tip-description {
                margin-top: 20px;
                color: #a8abb3;
                line-height: 20px;
            }

            .blue {
                font-size: 14px;
                color: #0067ed;
            }

            .btn-row {
                margin-top: 50px;
            }
        }
    }
}
</style>
